export default __webpack_public_path__ + "static/media/UserGuide_es_ES.a004b7ec.pdf";